"use strict";

var _toConsumableArray = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var crypto_1 = require("./crypto");

var rlp_1 = require("./rlp");
/** Transaction class defines VeChainThor's multi-clause transaction */


var Transaction =
/*#__PURE__*/
function () {
  _createClass(Transaction, null, [{
    key: "decode",

    /** decode from Buffer to transaction */
    value: function decode(raw) {
      try {
        var body = unsignedTxRLP.decode(raw);
        return new Transaction(body);
      } catch (_a) {
        var _body = txRLP.decode(raw);

        var sig = _body.signature;
        delete _body.signature;
        var tx = new Transaction(_body);
        tx.signature = Buffer.from(sig.slice(2), 'hex');
        return tx;
      }
    }
    /**
     * construct a transaction object with given body
     * @param body body of tx
     */

  }]);

  function Transaction(body) {
    _classCallCheck(this, Transaction);

    this.body = Object.assign({}, body, {
      reserved: body.reserved || []
    });
  }
  /**
   * returns transaction ID
   * null returned if something wrong (e.g. invalid signature)
   */


  _createClass(Transaction, [{
    key: "encode",

    /** encode into Buffer */
    value: function encode() {
      if (this.signature) {
        var sigHex = '0x' + this.signature.toString('hex');
        return txRLP.encode(Object.assign({}, this.body, {
          signature: sigHex
        }));
      }

      return unsignedTxRLP.encode(this.body);
    }
  }, {
    key: "id",
    get: function get() {
      if (!this.signature) {
        return null;
      }

      try {
        var signingHash = crypto_1.blake2b256(unsignedTxRLP.encode(this.body));
        var pubKey = crypto_1.secp256k1.recover(signingHash, this.signature);
        var signer = crypto_1.publicKeyToAddress(pubKey);
        return '0x' + crypto_1.blake2b256(signingHash, signer).toString('hex');
      } catch (_a) {
        return null;
      }
    }
    /** returns signer. null returned if no signature or not incorrectly signed */

  }, {
    key: "signer",
    get: function get() {
      if (!this.signature) {
        return null;
      }

      try {
        var signingHash = crypto_1.blake2b256(unsignedTxRLP.encode(this.body));
        var pubKey = crypto_1.secp256k1.recover(signingHash, this.signature);
        return '0x' + crypto_1.publicKeyToAddress(pubKey).toString('hex');
      } catch (_a) {
        return null;
      }
    }
    /** returns intrinsic gas it takes */

  }, {
    key: "intrinsicGas",
    get: function get() {
      return Transaction.intrinsicGas(this.body.clauses);
    }
  }]);

  return Transaction;
}();

exports.Transaction = Transaction;

(function (Transaction) {
  /**
   * calculates intrinsic gas that a tx costs with the given clauses.
   * @param clauses
   */
  function intrinsicGas(clauses) {
    var txGas = 5000;
    var clauseGas = 16000;
    var clauseGasContractCreation = 48000;

    if (clauses.length === 0) {
      return txGas + clauseGas;
    }

    return clauses.reduce(function (sum, c) {
      if (c.to) {
        sum += clauseGas;
      } else {
        sum += clauseGasContractCreation;
      }

      sum += dataGas(c.data);
      return sum;
    }, txGas);
  }

  Transaction.intrinsicGas = intrinsicGas;

  function dataGas(data) {
    var zgas = 4;
    var nzgas = 68;
    var sum = 0;

    for (var i = 2; i < data.length; i += 2) {
      if (data.substr(i, 2) === '00') {
        sum += zgas;
      } else {
        sum += nzgas;
      }
    }

    return sum;
  }
})(Transaction = exports.Transaction || (exports.Transaction = {}));

var unsignedTxRLP = new rlp_1.RLP({
  name: 'tx',
  kind: [{
    name: 'chainTag',
    kind: new rlp_1.RLP.NumericKind(1)
  }, {
    name: 'blockRef',
    kind: new rlp_1.RLP.TrimmedBlobKind(8)
  }, {
    name: 'expiration',
    kind: new rlp_1.RLP.NumericKind(4)
  }, {
    name: 'clauses',
    kind: {
      item: [{
        name: 'to',
        kind: new rlp_1.RLP.NullableBlobKind(20)
      }, {
        name: 'value',
        kind: new rlp_1.RLP.NumericKind(32)
      }, {
        name: 'data',
        kind: new rlp_1.RLP.VariableBlobKind()
      }]
    }
  }, {
    name: 'gasPriceCoef',
    kind: new rlp_1.RLP.NumericKind(1)
  }, {
    name: 'gas',
    kind: new rlp_1.RLP.NumericKind(8)
  }, {
    name: 'dependsOn',
    kind: new rlp_1.RLP.NullableBlobKind(32)
  }, {
    name: 'nonce',
    kind: new rlp_1.RLP.NumericKind(8)
  }, {
    name: 'reserved',
    kind: new rlp_1.RLP.RawKind()
  }]
});
var txRLP = new rlp_1.RLP({
  name: 'tx',
  kind: [].concat(_toConsumableArray(unsignedTxRLP.profile.kind), [{
    name: 'signature',
    kind: new rlp_1.RLP.VariableBlobKind()
  }])
});